var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27257 1.71846C2.32448 0.578068 3.91623 0 6.00283 0H6.75259V2.11359L6.14978 2.2343C5.12261 2.43973 4.40808 2.84386 4.0257 3.43692C3.79102 3.80205 3.7138 4.19193 3.6973 4.49859H5.25306H6.00283C6.41745 4.49859 6.75259 4.83373 6.75259 5.24835V10.4967C6.75259 11.3237 6.08005 11.9962 5.25306 11.9962H0.754479C0.339859 11.9962 0.00471439 11.6611 0.00471439 11.2465V7.49764L0.0069637 5.30908C0.000215821 5.22586 -0.142239 3.25398 1.27257 1.71846ZM13.5005 11.9962H9.00189C8.58727 11.9962 8.25212 11.6611 8.25212 11.2465V7.49764L8.25437 5.30908C8.24762 5.22586 8.10517 3.25398 9.51997 1.71846C10.5719 0.578068 12.1636 0 14.2502 0H15V2.11359L14.3972 2.2343C13.37 2.43973 12.6555 2.84386 12.2731 3.43692C12.0384 3.80205 11.9612 4.19193 11.9447 4.49859H13.5005H14.2502C14.6649 4.49859 15 4.83373 15 5.24835V10.4967C15 11.3237 14.3275 11.9962 13.5005 11.9962Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quoteLeft.7da2089fdd5b26064dfa9c8accce02f0.svg";
export { ForwardRef as ReactComponent };